import { Component, Injector, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AssessmentFormService } from "../assessment-form/assessment-form.service";
import { Observable } from "rxjs";
import { AssessmentQuestionBase } from "../assessment-form/models/assessment-question-base.model";
import { MainComponent } from "../main-component/main.component";
import { SearchAndSelect } from "../form/models/serachselect.model";

@Component({
    selector: 'app-assessment-engine',
    templateUrl: './assessment-engine.component.html',
    styleUrls: ['./assessment-engine.component.css'],
    standalone: false
})
export class AssessmentEngineComponent extends MainComponent implements OnInit {
    assessmentQues: any;
    config: any;
    defaultsetting = {
        "singleSelection": true,
        "allowSearchFilter": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": true
    }
    datasource = {
        "application": "form-template-engine",
        "resource": "system_template",
        "filter":"templateType:assessment_score",
        "key": "id",
        "query_id": "GET_PAGE"
    }
    public _currentData: any = {
        "form": {},
        "currentFormFields": {}
    };
    questions: AssessmentQuestionBase<any>[];
    assessment_template_id: any;
    constructor(
        public injector: Injector,
        public router: Router,
        public route: ActivatedRoute,
        private assessmentService: AssessmentFormService
    ) {
        super(injector, route);
    }
    ngOnInit(): void {
        this.config = {
            "submitButton": true,
            "cancelButton": true,
            "filterForm": false,
            "clearOnSave": false,
            "delegateSave": true,
            "cancelRoute": ''
          }
        this.assessmentQues = new SearchAndSelect({
            label: "Assessment Template",
            datasource: this.datasource,
            defaultsetting: this.defaultsetting,
            order: 1,
            visible: true,
            key: "assessment_template",
            required: true,
            getterKey: 'id',
            getterValue: 'name',
            options: false,
        });
        //   var id = "0ac17970-8ddb-11ee-b3e2-debdd8d98de0-77";
        //     this.baseService.getById(id, 'assessment_template', 'form-template-engine').subscribe(res => {
        //         this._currentData = JSON.parse(res.json_formio);
        // console.log(JSON.parse(res.json_formio));
        // this._currentData.form.components = [this.assessmentQues];
        // this.questions = this.assessmentService.buildQuestions(this.assessmentQues);
        // this.questions = this.assessmentService.buildQuestions(this._currentData.form.components);
        // });

    }
    onItemSelect(result) {
        // this.questions = null;
        this._currentData.currentFormFields = null;
        this.assessment_template_id = result.id;
        if (this.assessment_template_id) {
            var id = this.assessment_template_id;
            this.baseService.getById(id, 'system_template', 'form-template-engine').subscribe(res => {
                // this._currentData = JSON.parse(res.json_formio);
                // console.log(JSON.parse(res.json_formio));

                // this.questions = this.assessmentService.buildQuestions(this._currentData.form.components);
                
                this._currentData.currentFormFields = {};
                this._currentData.currentAction = 'ADD';
                let response = JSON.parse(res.json_data);
               
                for(var i = 0; i < response.length; i++){
                    response[i].fields = response[i]['fieldsObj'];
                    delete response[i].fieldsObj;
                }
                this._currentData.currentFormFields.blocks = response;
                this._currentData.currentFormFields.decorator = this.baseService.initDecorator("AssessmentTemplate", this.route);
            });
        }
    }
    onDeSelect(result) {
        // this.questions = null;
        this._currentData.currentFormFields = null;
    }
}